import HttpService, { BaseResponse } from "../base";
// Types
import type { CollectorDocuments } from "src/types/collectors";
import type { BaseApiResponse } from "src/types/http";

class CollectorsProvider extends HttpService {
	constructor() {
		super({ group: "data" });
	}

	/**
	 * get table collector
	 *
	 * @async
	 * @version 1.0.2
	 */
	public getTableCollectors(): BaseResponse<BaseApiResponse<CollectorDocuments>> {
		return this.httpService.get("table-collector");
	}

	/**
	 * get published extract table collector
	 *
	 * @async
	 * @version 1.0.2
	 */
	public getExtractedTableCollector(id: string): BaseResponse<BaseApiResponse<CollectorDocuments>> {
		return this.httpService.get(`table-collector/${id}`);
	}

	/**
	 * Export a single table-collector table as Excel or JSON
	 */
	public exportTable(tableId: string, format: "excel" | "json" = "excel"): BaseResponse {
		const isJson = format === "json";
		const pathPrefix = isJson ? "json/" : "";
		return this.httpService.get(`export/table-collector/${pathPrefix}${tableId}`, {
			responseType: isJson ? "json" : "blob",
		});
	}

	/**
	 * Fetch schema entities
	 *
	 * @async
	 */
	public getEntities(): BaseResponse {
		return this.httpService.get("entity");
	}

	/**
	 * Fetch database columns for a selected schema entity
	 *
	 * @async
	 */
	public getDBColumns(entity: string): BaseResponse {
		return this.httpService.get(`columns/db-columns/${entity}`);
	}

	/**
	 * Fetch master preprocessing functions list
	 *
	 * @async
	 */
	public getPreprocessingFunctions(): BaseResponse {
		return this.httpService.get("auto-extractor/preprocessing-functions");
	}

	/**
	 * Fetch all configs matched to a selected document context
	 *
	 * @async
	 */
	public getAutoExtractorConfigs(id: string): BaseResponse {
		return this.httpService.get(`auto-extractor/configs/documents/${id}`);
	}

	/**
	 * Create new Auto Extractor Config
	 *
	 * @async
	 */
	public postAutoExtractorConfigs(data: any): BaseResponse {
		return this.httpService.post("auto-extractor/configs", data);
	}

	/**
	 * Update existing Auto Extractor Config
	 *
	 * @async
	 */
	public putAutoExtractorConfig(id: string, data: any): BaseResponse {
		return this.httpService.put(`auto-extractor/configs/${id}`, data);
	}

	/**
	 * Create background preview generation job
	 *
	 * @async
	 */
	public postAutoExtractorPreview(id: string, type: string): BaseResponse {
		return this.httpService.post(`auto-extractor/preview/${id}`, null, {
			params: { type },
		});
	}

	/**
	 * Retrieve background preview execution details
	 *
	 * @async
	 */
	public getAutoExtractorPreviewJobDetails(id: string): BaseResponse {
		return this.httpService.get(`auto-extractor/preview/jobs/${id}`);
	}
}

const CollectorsService = new CollectorsProvider();

export default CollectorsService;
